import Common from '../common'
import echarts from 'echarts'
import axios from 'axios'
var Js = Common('dashboard')
export default {
	name: 'dashboard',
	mixins: [Js],
	components: {},
	data() {
		return {
			fields: [{
					key: 'id',
					label: 'ID',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
					width: 50
				},
				{
					key: 'type',
					label: '状态',
					application: ['编辑'],
					formatter: function(val, tests) {
						var testArray = ['未处理', '已处理']
						return testArray[val.type];
					},
					componentName: 'sls-select',
					optionsName: 'typeOptions',
					listType: 'normal',
					limit: 10,
					defaultProps: {
						label: 'text',
						value: 'value',
					},
					placeholder: '请选择状态',
					width: 100,
					header_search: {
						componentName: 'sls-select',
						optionsName: 'typeOptions',
						style: 'width:160px;margin-right:2px;',
						placeholder: '请选择状态',
						changeFunc: function(val, self) {
							if (val) {
								self.searchItem.type = val;
							} else {
								delete self.searchItem.type;
							};
							self.initMainData(true);
						},
					}
				},
				{
					key: 'title',
					label: '姓名',
					application: ['编辑'],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'content',
					label: '备注',
					application: ['编辑'],
					componentName: 'sls-textarea',
					listType: 'normal',
					dialogStyle: 'width:90%'
				},
				{
					key: 'phone',
					label: '电话',
					application: ['编辑'],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'create_time',
					label: '创建时间',
					listType: 'normal',
					placeholder: '请选择创建时间',

					width: 200,
				},
				{
					label: '操作',
					listType: 'deal',
					width: 200
				},
			],
			// 按钮配置
			btn_info: [



				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'list',
					text: function(data) {
						return '编辑'
					},
					func: {
						apiName: function(self) {
							return "api_messageUpdate"
						},
						formData: function(self) {
							return self.formData
						},
						postData: function(self) {
							var postData = {
								searchItem: {
									id: self.formData.id,
								},
								data: self.submitData
							};
							if (self.submitData.parentid && self.submitData.parentid == self.formData.id) {
								self.$$notify('父级ID和子级ID重叠', 'fail');
								return false;
							} else {
								return postData;
							};

						},
						callback: function(self) {
							self.initMessageData(true)
						}
					},
				},


				{
					type: 'danger',
					icon: 'delete',
					size: 'mini',
					funcType: 'submit',
					position: 'header',
					text: function(data) {
						return '删除选中'
					},
					func: {

						apiName: function(self) {
							return "api_routineUpdate"
						},

						postData: function(self) {
							var deleteArray = [];
							for (var i = 0; i < self.selectionArray.length; i++) {
								deleteArray.push(self.selectionArray[i].id);
							};
							var postData = {
								searchItem: {
									id: ['in', deleteArray],
								},
								data: {
									status: -1
								}
							};
							return postData;
						}

					},
				},

				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'list',
					text: function(data) {
						return '编辑信息'
					},
					func: {
						apiName: function(self) {
							if (JSON.stringify(self.user) == "{}") {
								return "api_userInfoAdd";
							} else {
								return "api_userInfoUpdate";
							};
						},
						formData: function(self) {
							return self.user
						},
						postData: function(self) {
							var postData = {
								searchItem: {
									id: self.formData.id,
								},
								data: self.submitData
							};
							if (self.submitData.parentid && self.submitData.parentid == self.formData.id) {
								self.$$notify('父级ID和子级ID重叠', 'fail');
								return false;
							} else {
								return postData;
							};

						},
						callback: function(self) {
							self.initUserInfoData()
						}
					},
				},


			],


			visitorPaginate: {
				count: 0,
				currentPage: 1,
				pagesize: 10,
				is_page: true,
				page_sizes: [10, 30, 60, 90],
				layout: 'total, sizes, prev, pager, next, jumper',
			},
			searchItem: {
				behavior: 1,
				transport_status: 0
			},
			startSearchItem: {
				behavior: 1,
				transport_status: 0
			},
			optionData: {
				labelOptions: [],
				typeOptions: [{
					text: '未处理',
					value: 0
				}, {
					text: '已处理',
					value: 1
				}],
			},
			otherData: {},
			UserInfo: {
				tableName: 'UserInfo',
				searchItem: {},
				fixSearchItem: {
					status: 1
				},
				key: 'user_no',
				middleKey: 'user_no',
				condition: 'in',
			},

			user: {},
			isSign: false,
			visitorData: [],
			echartsOptions: {},
			loading: false,
			timeArr: [],

			weatherTxt: '',
			weather: {},
			weatherData: {},

			echartsOptions1: null,
			echartsOptions2: null,

			rankData:[]
		}

	},

	mounted() {
		this.init()
	},
	computed: {
		token: function() {
			return this.$store.getters.getToken
		}
	},
	methods: {


		timeChange(e) {
			const self = this;
			if (e.value && e.value != null) {
				self.timeArr = [e.value[0] / 1000, e.value[1] / 1000];
			} else {
				self.timeArr = [];
			};

			console.log('timeChange', e)
		},

		/**
		 * 初始化
		 */
		init() {
			this.initMainData();
		},

		/**
		 *
		 */


		async initMainData(isNew) {

			const self = this;
			const postData = {};
			postData.token = self.$store.getters.getToken;
			var res = await self.$$api_statistic({
				data: postData
			});
			self.mainData = res.info;
			// self.weather = res.info.weather.data.forecast[0];
			// self.weatherData = res.info.weather.data;
			// self.weatherTxt = res.info.weather.data.ganmao;
			self.rankData = self.mainData.kcxsph;
			for(var i=0;i<self.rankData.length;i++){
				self.rankData[i].bannerImg = JSON.parse(self.rankData[i].bannerImg)
			}
			console.log('rankData', self.rankData)
			self.initVisitorData('echartsOptions1');
			self.initVisitorData('echartsOptions2');
		},


		/**
		 * 列表主函数
		 */
		async initVisitorData(type) {
			const self = this;
			var option = {
				color: ['#00c0dd', '#ffcf7c', '#aaaaff', '#ff6ba6', '#53e6a2'],
				title: {
					text: '订单统计'
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'cross',
						label: {
							backgroundColor: '#6a7985'
						}
					}
				},
				legend: {
					data: ['订单统计']
				},
				toolbox: {
					feature: {
						saveAsImage: {}
					}
				},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '3%',
					containLabel: true
				},
				xAxis: [{
					type: 'category',
					boundaryGap: false,
					data: []
				}],
				yAxis: [{
					type: 'value'
				}],
				series: [{
					name: '订单统计',
					type: 'line',
					stack: 'Total',
					smooth: true,
					lineStyle: {
						width: 0
					},
					showSymbol: false,
					areaStyle: {
						opacity: 0.8
					},
					emphasis: {
						focus: 'series'
					},
					data: []
				}, ]
			};
			self[type] = option;
			self.mainData.canlender.forEach((item, index) => {
				if (type == 'echartsOptions1') {
					option.series[0].data.push(item.orderCount)
					option.xAxis[0].data.push(self.$$timeto(item.s_time*1000,'ymd'))
				} else {
					option.color = ['#53e6a2'];
					option.title.text = '用户新增统计';
					option.legend.data[0] = '用户新增';
					option.series[0].name = '用户新增';
					option.series[0].data.push(item.userCount)
					option.xAxis[0].data.push(self.$$timeto(item.s_time*1000,'ymd'))
				}
			})
		},

	},


}



// WEBPACK FOOTER //
// ./src/views/dashboard/dashboard.js